import React, { useState, useEffect } from "react";
import { Container, Button, Form, Spinner } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { FaSearch, FaEdit, FaTrashAlt, FaEye } from "react-icons/fa";
import "../../Styles/yellocalfcss/CollectRegistrationFee.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";

const CollectRegistrationFee = () => {
  const navigate = useNavigate();
  const [message, setMessage] = useState("");
  const [filters, setFilters] = useState({
    invoiceId: "",
    student: "",
    rfid: "",
    email: "",
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [invoices, setInvoices] = useState([]);
  // const [isLoading, setIsLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const invoicesPerPage = 15;

  useEffect(() => {
    fetchFailedCollectFee();
  }, []);

  const fetchFailedCollectFee = async () => {
    setIsLoading(true);

    // You can use these if the API requires dynamic data
    const user_id = localStorage.getItem("user_id");
    const api_key = localStorage.getItem("api_key");
   const  customer_id= localStorage.getItem("customer_id");

    try {
      // 1. Fixed Payload Syntax
      const payload = {
        customer_id: customer_id,
        api_key: api_key,
        language: "en",
        user_id: user_id,
        status: "registrationfeecollection",
        action: "",
        student_name: "",
        ref_id: "",
        grade: "",
        email: "",
      };

      const response = await simplePostCall(
        ApiConfig.collectRegistrationFee,
        JSON.stringify(payload),
      );

      if (response?.searchModel) {
        // 2. Map API Response to Table Structure
        // Note: The API response provided is for Students, but the table expects Invoice Data.
        // I have mapped the available fields and put placeholders for missing financial data.
        const fetchedData = response.searchModel.map((item) => ({
          id: item.student_registration_id, // Used for Invoice ID column
          rfid: item.student_registration_rfid || "N/A",
          student: `${item.student_registration_first_name} ${item.student_registration_last_name}`,
          grade: item.student_registration_class,
          demandDate: formatDate(item.student_registration_application_date),
          dueDate: "-", // Not provided in API response
          amountTotal: "0.00", // Not provided in API response
          amountPaid: "0.00", // Not provided in API response
          balance: "0.00", // Not provided in API response
          fee_invoice_id: item.student_registration_id, // Used for navigation
        }));

        setInvoices(fetchedData);
      } else {
        setMessage(response?.message || "No results found");
        setInvoices([]);
      }
    } catch (error) {
      console.error("Error fetching details:", error);
      setMessage("Error fetching details");
    } finally {
      setIsLoading(false);
    }
  };

  // Helper function to format dates
  const formatDate = (dateString) => {
    if (!dateString) return "-";
    return dateString.split("T")[0];
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };

  const handleClear = () => {
    setFilters({ invoiceId: "", student: "", rfid: "", email: "" });
  };

  // Filter logic
  const filteredInvoices = invoices.filter((invoice) => {
    return (
      (filters.invoiceId === "" ||
        String(invoice.id)
          .toLowerCase()
          .includes(filters.invoiceId.toLowerCase())) &&
      (filters.student === "" ||
        String(invoice.student)
          .toLowerCase()
          .includes(filters.student.toLowerCase()))
    );
  });

  // Pagination Logic
  const indexOfLastInvoice = currentPage * invoicesPerPage;
  const indexOfFirstInvoice = indexOfLastInvoice - invoicesPerPage;
  const currentInvoices = filteredInvoices.slice(
    indexOfFirstInvoice,
    indexOfLastInvoice,
  );

  return (
    <div className="verification-main-wrapper">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Collect Registration Fees</h4>
      </div>

      <div className="yc-list-body">
        {/* Filters */}
        <div className="yc-list-filter">
          <div className="ff-search-wrap">
            <FaSearch className="ff-search-icon" />
            <Form.Control
              type="text"
              placeholder="ID Search"
              name="invoiceId"
              value={filters.invoiceId}
              onChange={handleChange}
              className="form-control ff-search-input"
            />
          </div>

          <div className="ff-search-wrap">
            <FaSearch className="ff-search-icon" />
            <Form.Control
              type="text"
              placeholder="Filter by Student"
              name="student"
              value={filters.student}
              onChange={handleChange}
              className="form-control ff-search-input"
            />
          </div>

          <Button onClick={handleClear} className="btn btn-primary">Clear</Button>
          <Button onClick={fetchFailedCollectFee} className="btn btn-primary">Search</Button>
        </div>

        {message && (
          <div className="alert alert-info">{message}</div>
        )}

        {/* Column Header */}
        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-10">
            <div className="yc-list-cell">Sr No</div>
            <div className="yc-list-cell">ID</div>
            <div className="yc-list-cell">First Name</div>
            <div className="yc-list-cell">Grade</div>
            <div className="yc-list-cell">App Date</div>
            <div className="yc-list-cell">Due Date</div>
            <div className="yc-list-cell">Amount</div>
            <div className="yc-list-cell">Paid</div>
            <div className="yc-list-cell">Balance</div>
            <div className="yc-list-cell">Actions</div>
          </div>
        </div>

        {/* Rows */}
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : currentInvoices.length > 0 ? (
          <div className="yc-list-row-list">
            {currentInvoices.map((invoice, index) => (
              <div key={index} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-10">
                  <div className="yc-list-cell">
                    {(currentPage - 1) * invoicesPerPage + index + 1}
                  </div>
                  <div className="yc-list-cell">{invoice.id}</div>
                  <div className="yc-list-cell">{invoice.student}</div>
                  <div className="yc-list-cell">{invoice.grade}</div>
                  <div className="yc-list-cell">{invoice.demandDate}</div>
                  <div className="yc-list-cell">{invoice.dueDate}</div>
                  <div className="yc-list-cell">
                    {invoice.amountTotal === "0.00" ? "-" : `$${invoice.amountTotal}`}
                  </div>
                  <div className="yc-list-cell">
                    {invoice.amountPaid === "0.00" ? "-" : `$${invoice.amountPaid}`}
                  </div>
                  <div className="yc-list-cell">
                    {invoice.balance === "0.00" ? "-" : `$${invoice.balance}`}
                  </div>
                  <div className="yc-list-cell yc-list-cell-actions">
                    <button
                      className="crf-collect-btn"
                      title="Collect this registration fee"
                      onClick={() =>
                        navigate(
                          `/collectpayment?invoice=${invoice.fee_invoice_id}`,
                        )
                      }
                    >
                      Collect Fee
                    </button>
                    <button
                      className="yc-action-icon"
                      title="View"
                      onClick={() => navigate(`/CustomerViewInvoice/${invoice.fee_invoice_id}`)}
                    >
                      <FaEye />
                    </button>
                    <button
                      className="yc-action-icon"
                      title="Send Invoice"
                      onClick={() => navigate(`/SendInvoice/${invoice.fee_invoice_id}`)}
                    >
                      <FaEdit />
                    </button>
                    <button
                      className="yc-action-icon yc-action-icon--danger"
                      title="Delete Invoice"
                      onClick={() => setMessage(`Delete Invoice ID: ${invoice.id}`)}
                    >
                      <FaTrashAlt />
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No Records Found</div>
        )}

        <div className="text-muted mt-3">
          Showing {currentInvoices.length > 0 ? indexOfFirstInvoice + 1 : 0} -{" "}
          {Math.min(indexOfLastInvoice, filteredInvoices.length)} of {filteredInvoices.length} items
        </div>
      </div>
    </div>
  );
};

export default CollectRegistrationFee;
